import { Injectable } from '@angular/core';
import BrowserUtils from '../utils/browser-utils';
import { ApiList } from 'src/environments/environment.types';
import { environment } from 'src/environments/environment';

type Params = {
  apiKey: keyof ApiList,
  oldBrowserFallbackPath: string,
  path: string
}

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  /**
   * Retorna o endpoint correto baseado no navegador.
   *
   * @param apiKey - A chave para identificar a API no objeto environment.apis
   * @param oldBrowserFallbackPath - O caminho do endpoint para navegadores antigos (Firefox 34)
   * @param path - O caminho do endpoint para navegadores modernos
   *
   * @returns O URL completo a ser utilizado.
   */
  getEndpoint({ apiKey, oldBrowserFallbackPath, path }: Params): string {
    if (BrowserUtils.isOldFirefox()) {
      const baseUrl = environment.apis[apiKey]?.url;
      if (!baseUrl) {
        throw new Error(`API key "${apiKey}" não encontrada em environment.apis`);
      }
      return `${baseUrl}${oldBrowserFallbackPath}`;
    }

    if (apiKey === 'cdc-portal-negociacao-cartao-bradesco') {
      return `${environment.apiURLService}${path}`;
    }

    if (apiKey === 'cdc-cobranca-renegociacao-service') {
      return `${environment.apiURLService}${path}`;
    }

    return `${environment.apiURLService}/v1${path}`;
  }
}